import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { Auth } from '@angular/fire/auth';

/**
 * Blume Admin Guard
 *
 * Gates the /blume-admin console on the `super_admin` custom claim — the SAME
 * authority the backend enforces (firestore.rules isSuper() + the v4
 * blumeAdmin_* callables' two-artefact gate). Every operation inside the
 * console is super-only server-side, so an @blumemethod.com address alone must
 * grant nothing: the email-domain god-mode is retired. Reading the claim from
 * the ID token keeps the client gate in lockstep with the rules.
 *
 * The claim rides the ID token, so a freshly-granted admin must sign out/in
 * (or refresh the token) before it appears. Use after authGuard, which
 * guarantees a signed-in user by the time this runs.
 */
export const blumeAdminGuard: CanActivateFn = async () => {
  const auth = inject(Auth);
  const router = inject(Router);

  const user = auth.currentUser;
  if (!user) {
    router.navigate(['/account']);
    return false;
  }

  const token = await user.getIdTokenResult();
  if (token.claims['super_admin'] === true) {
    return true;
  }

  router.navigate(['/account']);
  return false;
};
